import React, { createContext, useCallback, useContext, useRef, useState } from "react";

const CopilotCtx = createContext(null);

export function CopilotProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null); // { id, text }
  const idRef = useRef(0);

  const openCopilot = useCallback(() => setOpen(true), []);
  const closeCopilot = useCallback(() => setOpen(false), []);

  // Open panel and queue a prompt that the panel auto-sends once it mounts/opens.
  const askCopilot = useCallback((text, context) => {
    if (!text) return;
    idRef.current += 1;
    setPending({ id: idRef.current, text, context });
    setOpen(true);
  }, []);

  const clearPending = useCallback(() => setPending(null), []);

  return (
    <CopilotCtx.Provider value={{ open, openCopilot, closeCopilot, askCopilot, pending, clearPending }}>
      {children}
    </CopilotCtx.Provider>
  );
}

export function useCopilot() {
  const ctx = useContext(CopilotCtx);
  if (!ctx) throw new Error("useCopilot must be used inside CopilotProvider");
  return ctx;
}
